import BankName from "./bankName";
export default BankName;